<template>
	<div class="pro_main">
		<el-button type="primary" @click="add()">+商品类目</el-button>
		<p class="tip">根据国家法律法规与平台运营规范，不同的电商类目需要相应的服务资质与商品资质</p>

		<el-table v-loading="loading" :data="tableData" style="width: 100%;">
			<el-table-column prop="pname" label="经营大类" align="center" width="120">
			</el-table-column>
			<el-table-column prop="name" label="一级类目" align="center">
			</el-table-column>
			<el-table-column label="类目资质" align="center">
				<template slot-scope="scope">
					<div class="qual_info" v-if="scope.row.qual_img.length > 0">
						<img class="qual_img" :src="scope.row.qual_img[0]" />
						<div class="preview" @click="preview(scope.$index)">（点击查看）</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" label="申请时间" align="center">
			</el-table-column>
			<el-table-column prop="status_txt" label="状态" align="center">
				<template slot-scope="scope">
					<template v-if="scope.row.status == 2">
						<div class="status_txt red_txt">{{scope.row.status_txt}}</div>
						<el-tooltip :content="scope.row.reason"  placement="top">
						  <el-button type="text" style="padding: 0">（查看原因）</el-button>
						</el-tooltip>
					</template>
					<div v-else class="status_txt">{{scope.row.status_txt}}</div>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页器 -->
		<div class="block" style="padding: 40px;background: #ffffff;" v-if="tableData.length > 0">
			<el-pagination background align='center' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
				layout="total, prev, pager, next, jumper" :pager-count="5" :total="total">
			</el-pagination>
		</div>
		
		<preview-imgs title="查看资质" refund_reason="" :show="showPreview" :imgs="imgs" :imgs_index="imgs_index" @close="closePreview" @change="changeImgsIndex"></preview-imgs>
	</div>
</template>

<script>
	import {
		getCategoryList
	} from '@/api/goods';
	import previewImgs from '@/components/preview-imgs.vue';

	export default {
		components: {
			previewImgs
		},
		data() {
			return {
				currentPage: 0, // 当前页码
				pageSize: 10, // 每页条数
				total: 0, // 总条数
				loading: false,
				tableData: [],
				showPreview: false, //预览图片
				imgs: [],
				imgs_index: 0,
			}
		},
		created() {
			let keypage = localStorage.getItem('keypage');
			let activeName = localStorage.getItem('activeName');
			if (keypage) {
				this.currentPage = parseInt(keypage);
				this.activeName = activeName
				localStorage.setItem('keypage', '')
				localStorage.setItem('activeName', '')
			}
			this.getlist();
		},
		methods: {
			changeImgsIndex(res) {
				this.imgs_index = res.index;
			},
			/* 组件回调 */
			closePreview() {
				this.showPreview = false;
			},
			getlist() {
				let currentPage = this.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				getCategoryList({
					start: currentPage * 10,
				}).then(res => {
					if (res.code == 0) {
						this.loading = false;
						this.total = res.data.count;
						this.tableData = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			add() {
				localStorage.setItem('keypage', this.currentPage);
				localStorage.setItem('activeName', this.activeName);
				this.$router.push({
					path: '/product/category-apply',
					query: {
						
					}
				});
			},
			preview(index) {
				this.imgs = this.tableData[index].qual_img;
				this.imgs_index = 0;
				this.showPreview = true;
			},
			//切换标签页
			handleClick(tab, event) {
				this.currentPage = 0;
				this.getlist();
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getlist();
			},
		}
	}
</script>

<style scoped>
	.father-main {
		overflow: auto;
	}

	.pro_main {
		min-height: 88vh;
		background-color: #ffffff;
		padding-left: 20px;
		padding-top: 20px;
		padding-right: 10px;
	}

	.pro_main .el-tabs__header {
		margin: 0;
	}

	.qual_info {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.qual_img {
		width: 40px;
		height: 40px;
		margin-left: 60px;
		object-fit: cover;
		border-radius: 2px;
	}

	.preview {
		padding: 10px 0;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #0486FE;
		line-height: 20px;
		cursor: pointer;
	}

	.el-tooltip__popper {
		max-width: 20%;
	}

	.el-tooltip__popper,
	.el-tooltip__popper.is-dark {
		background: rgb(48, 65, 86) !important;
		color: #fff !important;
		line-height: 24px;
	}

	.tip {
		margin-top: 15px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	.status_txt{
		font-size: 14px;
		color: #333333;
	}
	.red_txt{
		color: #F56C6C;
	}
</style>
